import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "successIcon"]
  static values = { 
    url: String,
    attribute: String
  }

  connect() {
    console.log("Editable controller connected", this.element)
    this.originalValue = this.inputTarget.value
  }

  save(event) {
    console.log("Save triggered", event)
    if (this.inputTarget.value === this.originalValue) {
      console.log("No change, skipping save")
      return
    }
    
    console.log(`Saving ${this.attributeValue} with value ${this.inputTarget.value}`)
    
    // Create the form data
    const formData = new FormData()
    formData.append(`product[${this.attributeValue}]`, this.inputTarget.value)
    
    // Get CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    
    // Save the original value before the request in case we need to revert
    const newValue = this.inputTarget.value
    
    // Make the AJAX request
    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': csrfToken || '',
        'Accept': 'application/json'
      },
      body: formData
    })
    .then(response => {
      console.log("Response status:", response.status)
      if (response.ok) {
        // Update was successful
        this.originalValue = newValue
        this.showSuccessIcon()
        return response.json().catch(() => ({})) // Try to parse JSON, but continue if it fails
      } else {
        // Revert to original value on error
        this.inputTarget.value = this.originalValue
        throw new Error('Update failed')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      this.inputTarget.value = this.originalValue
    })
  }

  showSuccessIcon() {
    if (!this.hasSuccessIconTarget) return
    
    this.successIconTarget.classList.remove('hidden')
    setTimeout(() => {
      this.successIconTarget.classList.add('hidden')
    }, 2000)
  }

  onBlur(event) {
    console.log("Blur event", event)
    this.save(event)
  }
  
  onKeydown(event) {
    if (event.key === "Enter") {
      console.log("Enter key pressed")
      event.preventDefault()
      this.save(event)
      
      // Move focus to next element
      const inputs = Array.from(document.querySelectorAll('input.editable-input'))
      const currentIndex = inputs.indexOf(this.inputTarget)
      const nextInput = inputs[currentIndex + 1]
      if (nextInput) {
        nextInput.focus()
      }
    }
  }
}